// src/components/OrdersPage.jsx
import React, { useEffect, useState } from "react";
import MenuLayout from "./MenuLayout";
import "../styles/OrdersPage.css";
import { getOrders } from "../api/orders";

const statusLabel = (status) => {
  if (status === "approved") return "تایید شده";
  if (status === "rejected") return "رد شده";
  if (status === "pending") return "در انتظار تایید";
  return status || "نامشخص";
};

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await getOrders();
        setOrders(data || []);
      } catch (err) {
        setError(err.message || "خطا در دریافت سفارش‌ها");
      }
    };
    fetchOrders();
  }, []);

  return (
    <MenuLayout>
      <div className="orders-page">
        <header className="orders-header">
          <h1 className="orders-title">سفارشات کاربر</h1>
          <p className="orders-subtitle">
            امیدواریم این چالش ها به سودهای بی کران تو ختم بشه
          </p>
        </header>

        <div className="orders-table">
          <div className="orders-head">
            <span>شماره سفارش :</span>
            <span>وضعیت :</span>
            <span>مبلغ سفارش:</span>
            <span>نوع حساب :</span>
            <span>تاریخ ایجاد:</span>
            <span></span>
          </div>

          <div className="orders-body">
            {orders.map((o, idx) => (
              <div className="orders-row" key={o.id || idx}>
                <span>{o.order_number}</span>
                <span className="orders-status">{statusLabel(o.status)}</span>
                <span className="orders-amount">{o.amount} USD</span>
                <span>{o.account_type}</span>
                <span>{o.created_at}</span>
                <span>
                  <button
                    className={`orders-detail-btn ${o.status === "pending" ? "orders-detail-btn-primary" : ""}`}
                  >
                    جزئیات سفارش
                  </button>
                </span>
              </div>
            ))}
            {orders.length === 0 && !error && (
              <div className="orders-empty">سفارشی یافت نشد.</div>
            )}
            {error && <div className="orders-empty">{error}</div>}
          </div>
        </div>
      </div>
    </MenuLayout>
  );
};

export default OrdersPage;
